// -------------------------------------------
// JavaScript Accordion/Tabs
// Author: Globalia
// Licensed under the WTFPL license
// -------------------------------------------
// ...


( function( global ) { // eslint-disable-line

    var pluginName = 'grForm';

    // Constructor

    function grForm(selector) {

        // Create global references
        this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;

        // Retrieve plugin custom parameters
        this.param = this.selector.getAttribute('gr-form').split(' ');

        // Init grPlugin
        this.init();
    }

    grForm.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        } else {
            // Call sub-plugins
            for (var i = 0, len = this.param.length; i < len; i++) {
                var attr = this.param[i];
                if (attr == '')  {

                }
            }

            // Flag the plugin as ready
            this.ready = true;
            global.methods.toggleAttributeValue(this.selector, 'gr-form', 'ready');
            if (global.verbose) console.log(pluginName + '(' + this.selector + '): ready');
        }
    };

    // Destroy - remove listeners to prevent from memory leak
    grForm.prototype.destroy = function destroy() {

        if (global.verbose) console.log(pluginName + ': destroyed');
    };

    // jQuery wrapper, if available
    if(window.jQuery) {
        $.fn[pluginName] = function () {
            return this.each(function() {
                // add plugin to element data
                if (!$.data(this, pluginName) ) $.data(this, pluginName, new grForm(this));
            });
        };
    }

    // Auto-Instantiation
    var all = {}, index;
    if (document.querySelectorAll('form[gr-form]').length) {
        window.groots.grForm = { instances: {} };
        all = document.querySelectorAll('form[gr-form]');
        index = -1;
        while (all[++index])
            global.grForm.instances[index] = new grForm(all[index]);
    }

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grForm;
    // Export to Browser
    else global[pluginName] = grForm; // eslint-disable-line

}( window.groots ));
